require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/$.core').Object.setPrototypeOf;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/fn/object/set-prototype-of.js
// module id = 1910
// module chunks = 0